import {Person} from './person';
import {Sterbefall} from './sterbefall';
import {Verstorbener} from './verstorbener';


/**
 * Speichert und lädt Daten im JSON-Format.
 *
 * @author Andreas Wenger <andi@xenoage.com>
 */
export class SterbefallIO {

  private personenListe : Person[] = [];

  /**
   * Speichert einen Sterbefall in JSON.
   * Das Format entspricht nicht ganz der Klassenhierarchie:
   * Personen werden getrennt gespeichert und dann mit Index referenziert, z.B.
   * { personen: [{Person1}, {Person2}]}, ..., anmelder: { personIndex: 1 } }.
   * Zu instantiierende Klassen werden markiert mit { class: "Verstorbener" }
   */
  saveSterbefall(sterbefall: Sterbefall) : Object {
    let ret = {};
    let s = sterbefall;
    //Personen-Liste speichern
    this.personenListe = [];
    let personenListeJson : Person[] = [];
    let allePersonen = [s.verstorbener, s.ehepartner, s.vater, s.mutter, s.anmelder, s.grabrecht, s.kostentraeger].concat(s.verwandte);
    for (let person of allePersonen) {
      if (this.personenListe.indexOf(person) == -1) { //Person noch nicht referenziert?
        this.personenListe.push(person);
        let objPerson = Object.assign({}, person); //Copy
        if (person instanceof Verstorbener)
          objPerson["class"] = "Verstorbener";
        else
          objPerson["class"] = "Person";
        personenListeJson.push(objPerson);
      }
    }
    ret["personen"] = personenListeJson;
    //Nun die restlichen Daten rekursiv speichern.
    //Wenn wir auf bestimmte Klassen treffen, diese gesondert behandeln.
    for (let property in sterbefall)
      ret[property] = this.save(sterbefall[property]);
    return ret;
  }

  private save(source: any) : any {
    //Funktionen ignorieren
    if (typeof source == 'function') {
      return undefined;
    }
    //Array
    else if (source instanceof Array) {
      let target = [];
      for (let childItem in source) {
        target.push(this.save(source[childItem]));
      }
      return target;
    }
    //Person oder Unterklasse von Person: Nur Referenz speichern
    else if (source instanceof Person) {
      let target = { personIndex: this.personenListe.indexOf(<Person>source) };
      return target;
    }
    //Objekt
    else if (source instanceof Object) {
      let target = {};
      for (let childItem in source) {
        target[childItem] = this.save(source[childItem]);
      }
      return target;
    }
    //Ansonsten unverändert speichern
    else {
      return source;
    }
  }

  /**
   * Lädt einen Sterbefall aus JSON.
   * Zum Format siehe die save-Methode.
   */
  loadSterbefall(source: Object) : Sterbefall {
    let ret = new Sterbefall();
    //Überprüfe Versionsnummer
    if (source["schema"] != ret.schema) {
      console.log("Incompatible schema version: " + source["schema"]);
      return undefined;
    }
    //Lade Personen (ggf. Subklassen)
    this.personenListe = [];
    for (let o of source["personen"]) {
      let person : Person;
      if (o["class"] == "Verstorbener")
        person = new Verstorbener();
      else if (o["class"] == "Person")
        person = new Person();
      else
        throw new Error("Unknown Person class: " + o["class"]);
      this.copyAllProperties(o, person);
      this.personenListe.push(person);
    }
    //Lade Daten rekursiv. Wenn wir auf Personen treffen, diese einsetzen
    for (let property in source) {
      if (source[property] == undefined) //falls z.B. Funktionsnamen im JSON-Objekt stecken
        continue;
      if (property != "personen") //nur intern in JSON-Struktur verwendet
        ret[property] = this.load(source[property]);
    }
    return ret;
  }

  private load(source: any) : any {
    //Objekt beinhaltet Person: diese laden (vorhandene Daten überschreiben)
    if (source["personIndex"] != undefined) {
      return this.personenListe[source.personIndex];
    }
    //Array
    else if (source instanceof Array) {
      let target = [];
      for (let childItem in source) {
        target.push(this.load(source[childItem]));
      }
      return target;
    }
    //Objekt
    else if (source instanceof Object) {
      let target = {};
      for (let childItem in source) {
        target[childItem] = this.load(source[childItem]);
      }
      return target;
    }
    //Ansonsten unverändert laden
    else {
      return source;
    }
  }

  private copyAllProperties(source: Object, target: Object) {
    for (let property in source)
      if (property != "class" && property != "personIndex")
      target[property] = source[property];
  }

}



// WEBPACK FOOTER //
// ./src/model/sterbefall.io.ts